import React from 'react';
import { renderFieldDisplay, dateFormat } from '../../util';
import { medioPago, condicionVenta } from '../../catalogos';

const Encabezado = (props) => {
  const { data } = props;

  const getCondicionVenta = (value) => {
    return condicionVenta.filter((item) => item?.value === value)[0]?.display;
  };

  const getMedioPago = (value) => {
    return medioPago.filter((item) => item?.value === value)[0]?.display;
  };

  return (
    <div key={data.Id}>
      <div className="ui grid encabezado-section">
        <div className="section-header">
          <h4>Información del documento</h4>
        </div>
        <div className="one column row min-padding">
          <div className="sixteen wide column clave-label">
            {renderFieldDisplay('Clave documento:', data.Clave)}
          </div>
        </div>
        <div className="doubling four column row min-padding">
          <div className="column">
            {renderFieldDisplay('Fecha emisión:', dateFormat(data.FechaEmision))}
          </div>
          <div className="column">
            {renderFieldDisplay('Medio de pago:', getMedioPago(data.MedioPago))}
          </div>
          <div className="column">
            {renderFieldDisplay('Condición de venta:', getCondicionVenta(data.CondicionVenta))}
          </div>
          <div className="column">
            {renderFieldDisplay('Plazo credito:', data.PlazoCredito)}
          </div>
        </div>

      </div>
    </div>
  )
};

export default Encabezado;